<template>
  <div class="user-center-collection">
    <Dialog ref="dialog" :config="config"> </Dialog>
    <div>
      <div class="ohead">
        <el-input
          class="uiInput searchInput"
          v-model="form.keywords"
          :placeholder="$fanyi('请输入关键词搜索')"
          prefix-icon="el-icon-search"
          clearable
          @keyup.enter.native="getGoodsLists"
        />
        <el-button class="uiBtn uiGreen searchBtn" @click="getGoodsLists">{{
          $fanyi("搜索")
        }}</el-button>
        <div class="btns">
          <el-button class="uiBtn uiMintBlue" @click="delGoods('', '', 'all')">
            {{ $fanyi("选中移出") }}
          </el-button>
        </div>
      </div>
      <div class="tallys">
        <span
          :class="item.titleChecked ? 'active' : ''"
          @click="tabBtnClick(item)"
          v-for="(item, index) in tagLists"
          :key="index"
          >{{ item.tag_name }}</span
        >
      </div>

      <div
        class="SearchConterCrosswise_public goods"
        v-if="goodsList.length != 0"
        v-loading="loading"
      >
        <div
          class="SearchConterCrosswiseCon"
          v-for="(item, index) in goodsList"
          :key="index"
        >
          <div class="SearchConterCrosswiseImgBox">
            <input
              :checked="item.checked"
              type="checkbox"
              name=""
              id=""
              @click="item.checked = !item.checked"
              class="check-box"
            />
            <div class="obtns">
              <el-popover placement="right" trigger="click">
                <div @click.stop class="pop-up" v-if="item.showTagWin">
                  <div class="tag-list">
                    <div
                      class="tag-item"
                      v-for="(otem, ondex) in tagLists"
                      :key="ondex"
                    >
                      <label class="tag-checkbox">
                        <input
                          type="checkbox"
                          v-model="otem.checked"
                          @change="checkTagAdd(item.id, item)"
                        />
                        <span class="tag-name" :title="otem.tag_name">{{
                          otem.tag_name
                        }}</span>
                      </label>
                      <img
                        class="del-icon"
                        @click="delTag(otem.tag_id, ondex)"
                        src="../../../../assets/newImg/shanchu.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="addTagBtn">
                    <el-input
                      class="uiInput"
                      size="small"
                      v-model="addTagTxt"
                      @keyup.enter.native="addTag(item)"
                    >
                    </el-input>
                    <el-button class="uiBtn uiGreen" @click="addTag(item)">
                      {{ $fanyi("添加") }}
                    </el-button>
                  </div>
                </div>

                <img
                  slot="reference"
                  @click.stop="goodsTagOpen(item)"
                  src="../../../../assets/user-img/biaoQian.svg"
                  alt=""
                  class="tagIcon"
                />
              </el-popover>

              <img
                @click="delGoods(index, item)"
                src="../../../../assets/user-img/lajiTung.svg"
                alt=""
                class="delIcon"
              />
            </div>
            <div
              class="SearchConterCrosswiseImg"
              @click="$fun.toCommodityDetails(item.goods_id, item)"
            >
              <el-image :src="item.image_url">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </div>
          </div>
          <div class="rests">
            <p class="goodsTitle flex acenter" :title="item.title">
              <img
                :src="$fun.goodsCategoryIcon(item.from_platform)"
                alt=""
                class="platform-goods-icon"
              />
              <span> {{ item.title }}</span>
            </p>
            <p class="flex acenter priceRow">
              <span class="eurPrice"
                >{{
                  $fun.EURNumSegmentation(
                    $fun.ceil(item.price * $store.state.exchangeRate),
                  )
                }}€</span
              >
              <span class="rmbPrice"
                >{{ $fun.RMBNumSegmentation(item.price) }}¥</span
              >
            </p>
          </div>
        </div>
      </div>

      <div v-else class="tishi">
        {{ $fanyi(pageMsg) }}
      </div>
      <div class="allpag">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from "../../../../components/public/Dialog.vue";

export default {
  data() {
    return {
      pageMsg: "暂无数据",
      tagLists: [], //标签列表
      goodsList: [], //收藏商品列表
      addTagTxt: "", //添加标签的文本
      loading: true,
      total: 0,
      form: {},
      config: {
        top: "20vh",
        width: "500px",
        title: this.$fanyi("提示"),
        btnTxt: [this.$fanyi("删除"), this.$fanyi("取消")],
      }, // 弹框属性
    };
  },
  components: {
    Dialog,
  },
  computed: {},
  created() {
    this.form.pageSize = 12;
    this.getTagData();
    this.getGoodsLists();
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    // 删除商品
    delGoods(index, item, type) {
      var ids = [];
      this.goodsList.forEach((item) => {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var idsstr = ids.join(",");

      if (ids.length == 0 && type == "all") {
        return this.$message.warning(this.$fanyi("请至少选择一个商品"));
      }

      this.$refs.dialog.open(
        this.$fanyi("是否删除选中的商品"),
        () => {
          this.$api
            .favoriteGoodsDelete(
              type == "all" ? { id: idsstr } : { id: item.id },
            )
            .then((res) => {
              if (res.code != 0) return;
              if (
                Number(this.total) % Number(this.form.pageSize) == 1 &&
                this.form.page >
                  parseInt(Number(this.total) / Number(this.form.pageSize))
              ) {
                this.form.page--;
              }

              this.getGoodsLists();
              this.getTagData();
            });
        },
        () => {},
      );
    },
    // 添加商品标签
    async addTag(item) {
      this.$api
        .favoriteTagAdd({
          type: 1,
          tag_name: this.addTagTxt,
        })
        .then((res) => {
          //console.log("favoriteTagDelete", res);
          if (res.code != 0) return;
          this.addTagTxt = "";
          // 重新获取标签列表
          this.$api.favoriteTagList({ type: "1" }).then((res) => {
            //console.log("favoriteTagList", res);
            this.tagLists = res.data;
            // 调用处理标签列表事件
            this.tagDataProcessing();
            this.goodsTagOpen(item);
            this.$forceUpdate();
          });
        });
    },
    // 删除商品标签
    delTag(id, index) {
      this.$api
        .favoriteTagDelete({
          tag_id: id,
        })
        .then((res) => {
          //console.log("favoriteTagDelete", res);
          if (res.code != 0) return;
          this.tagLists.splice(index, 1);
        });
    },
    // 将商品分配到选中的标签里去
    checkTagAdd(id, item) {
      let ids = [];
      this.tagLists.forEach((item) => {
        if (item.checked) ids.push(item.tag_id);
      });
      //console.log(this.tagLists);
      ids = ids.join(",");
      let datas = {
        id: id,
      };
      if (ids) {
        datas.tag_ids = ids;
      }
      this.$api.favoriteGoodsToTags(datas).then((res) => {
        //console.log("favoriteGoodsToTags", res);
        if (res.code != 0) return;
        item.tag_ids = ids;
      });
    },
    // 全局鼠标点击事件
    bodyCloseMenus() {
      // 关闭所有商品的标签弹窗
      this.goodsList.forEach((item) => {
        item.showTagWin = false;
      });
      this.$forceUpdate();
    },
    //打开单个商品标签弹窗
    goodsTagOpen(item) {
      //console.log(item);
      // 关闭所有标签列表的弹窗
      this.goodsList.forEach((item) => {
        item.showTagWin = false;
      });
      let goodsTagIds = item.tag_ids.split(",");

      // 初始化商品标签列表数据
      this.tagLists.forEach((item) => {
        //console.log(goodsTagIds, String(item.tag_id));
        if (goodsTagIds.indexOf(String(item.tag_id)) != -1) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });

      item.showTagWin = true;
      this.$forceUpdate();
    },
    // 标签按钮点击事件
    tabBtnClick(item) {
      // 设置选中便签的值
      item.titleChecked = !item.titleChecked;
      this.form.page = 1;
      this.getGoodsLists("tagGoods");
    },
    // 获取商品收藏夹标签列表并调用商品收藏夹列表获取函数
    getTagData() {
      this.$api.favoriteTagList({ type: "1" }).then((res) => {
        //console.log("favoriteTagList", res);
        this.tagLists = res.data;
        // 调用处理标签列表事件
        this.tagDataProcessing();
        // 调用获取商品收藏夹列表事件
      });
    },
    // 获取商品收藏夹列表
    getGoodsLists(type) {
      let datas = {
        pageSize: this.form.pageSize,
        page: this.form.page,
        keywords: this.form.keywords,
      };
      let tagIds = [];
      // 如果有筛选就循环遍历获取选中的标签id传给接口

      this.tagLists.forEach((item) => {
        if (item.titleChecked) tagIds.push(item.tag_id);
      });
      tagIds = tagIds.join(",");
      datas.tag_ids = tagIds;

      this.$api.favoriteGoodsList(datas).then((res) => {
        //console.log("favoriteGoodsList", res);
        this.loading = false;
        this.goodsList = res.data.data;
        this.total = res.data.total;
      });
      this.dataProcessing();
    },
    // 处理收藏夹标签数据
    tagDataProcessing() {
      this.tagLists.forEach((item) => {
        item.checked = false;
        item.titleChecked = false;
      });
    },
    // 处理收藏夹商品数据
    dataProcessing() {
      this.goodsList.forEach((item) => {
        item.showTagWin = false;
        item.checked = false;
      });
    },
    handleSizeChange(val) {
      this.form.page_num = val;
      this.form.page = 1;
      this.getGoodsLists();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getGoodsLists();
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.user-center-collection {
  width: 100%;

  > div {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    padding: 20px;
    border-radius: 12px;

    .ohead {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .searchInput {
        min-width: 0;
        margin-right: 12px;
        width: 360px;

        /deep/ .el-input__inner {
          height: 40px;
          font-size: 14px;
          border-radius: 8px;
          border: 0.5px solid #d0d5dd;
          transition: border-color 0.3s;
          &::placeholder {
            color: #d0d5dd;
          }
          &:focus {
            border-color: #009246;
          }
        }

        /deep/ .el-input__prefix .el-input__icon {
          font-size: 15px;
          color: #000000;
        }
      }

      .searchBtn {
        height: 40px;
      }
      .btns {
        margin-left: auto;
        button {
          height: 40px;
        }
      }
    }
    .tallys {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 24px;
      span {
        @extend .dip;
        height: 28px;
        border-radius: 8px;
        border: 1px solid #eaecf0;
        padding: 4px 6px;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
        &.active {
          border: 1px solid #009246;
          color: #009246;
        }
      }
    }
    .goods {
      display: flex;
      flex-wrap: wrap;
    }
    .goods.SearchConterCrosswise_public {
      gap: 15px;
      .SearchConterCrosswiseCon {
        $size: 190px;
        width: $size;
        margin: 0 0;
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .SearchConterCrosswiseImgBox {
          position: relative;
          width: $size;
          height: $size;

          .check-box {
            width: 22px;
            height: 22px;
            background-color: #ffffff;
            border-radius: 6px;
            border: none;
            margin: 0;
            padding: 0;
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 2;
            cursor: pointer;
            -webkit-appearance: none;
            -webkit-user-select: none;
            user-select: none;
            transition: background-color ease 0.1s;
            &:checked {
              background: #009246;
            }
            &:checked::after {
              content: "";
              top: 5px;
              left: 5px;
              position: absolute;
              background: transparent;
              border: #fff solid 2px;
              border-top: none;
              border-right: none;
              height: 5px;
              width: 9px;
              transform: rotate(-45deg);
            }
          }

          .obtns {
            position: absolute;
            top: 10px;
            right: 10px;
            background: rgba(255, 255, 255, 0.85);
            border-radius: 6px;
            display: flex;
            align-items: center;
            padding: 4px 8px;
            z-index: 2;
            gap: 10px;

            img {
              width: 18px;
              height: 18px;
              cursor: pointer;
              display: block;
            }
          }

          .SearchConterCrosswiseImg {
            width: $size;
            height: $size;
            .el-image {
              width: $size;
              height: $size;
            }
          }
        }

        .rests {
          padding: 12px;
          display: flex;
          flex-direction: column;
          .goodsTitle {
            font-size: 14px;
            color: #333;
            line-height: 20px;
            .platform-goods-icon {
              height: 14px;
              max-width: 32px;
              border-radius: 2px;
            }
            span {
              @extend .text-overflow-one;
            }
          }
          .priceRow {
            display: flex;
            align-items: baseline;
            line-height: 24px;
            .eurPrice {
              font-size: 18px;
              font-weight: 700;
              color: #009246;
            }
            .rmbPrice {
              font-size: 16px;
              color: #7a869a;
              font-weight: 600;
            }
          }
        }
      }
    }
    .tishi {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
      font-size: 25px;
      font-weight: bold;
      color: #bcb8b8;
    }
    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 25px 0;
    }
  }
}

.pop-up {
  width: 240px;
  .tag-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }
  .tag-item {
    display: flex;
    align-items: center;
    .tag-checkbox {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      margin: 0;
      cursor: pointer;
      font-weight: normal;
      input[type="checkbox"] {
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        margin: 0;
        cursor: pointer;
      }
      .tag-name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .addTagBtn {
    display: flex;
    align-items: center;
    gap: 10px;
    .uiInput {
      height: 32px;
    }
    .uiBtn {
      height: 32px;
    }
  }
}
</style>
